import React, { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import { useAddCategoryMutation } from "../../Redux/Apis/Category";
import { objectValidator } from "../../Utils";
import { useUploadImageMutation } from "../../Redux/Apis/General";
import "./style.css";

const SECTIONS = [
  { value: 'pros', label: 'The Pros' },
  { value: 'barn', label: 'The Barn' },
  { value: 'calcutta', label: 'Calcutta' },
  { value: 'greenskeeping', label: 'Greenskeeping' },
];

const AddCategory = () => {

  const navigate = useNavigate()
  const ref = useRef()

  useEffect(() => {
    document.title = 'Landing List | Add Category';
  }, []);

  const [add, { isLoading, isSuccess, data }] = useAddCategoryMutation();
  const [addImage, { isLoading: imageLoading }] = useUploadImageMutation();

  const [name, setName] = useState("")
  const [section, setSection] = useState("pros")
  const categoryRef = useRef()
  const [categoryImage, setCategoryImage] = useState(null)
  const [subcategories, setSubcategories] = useState([""])
  const [subcategoriesImages, setSubcategoriesImages] = useState([])

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message)
      navigate('/categories')
    }
  }, [isSuccess]);

  const onClickSave = async () => {

    let validate = objectValidator({ name, subcategories })

    if (validate) {

      let s = []
      let iconPath = undefined

      if (categoryImage) {
        const formdata = new FormData()
        formdata.append("image", categoryImage)
        await addImage(formdata).then(res => {
          iconPath = res?.data?.data?.path
        })
      }

      for (let index = 0; index < subcategories.length; index++) {

        const subcategory = subcategories[index]
        const element = subcategoriesImages[index];

        let formdata = new FormData()
        formdata.append("image", element)
        await addImage(formdata).then(res => {
          s.push({ name: subcategory, icon: res?.data?.data?.path })
        })

      }

      add({
        name,
        section,
        icon: iconPath,
        subcategories: s
      })

    }

  }

  const onManipulateSubcategory = (operator, index) => {
    if (operator === "add") {
      let temp = [...subcategories]
      if (temp[temp.length - 1] === "") {
        return toast.error("Please fill the field")
      }
      setSubcategories(e => [...e, ""])
    } else if (operator === "minus") {
      let temp = [...subcategories]
      let tempImages = [...subcategoriesImages]
      temp.splice(index, 1);
      tempImages.splice(index, 1);
      setSubcategories(temp)
      setSubcategoriesImages(tempImages)
    }
  }

  const onChangeSubcategory = (index, value) => {
    let temp = [...subcategories]
    temp[index] = value
    setSubcategories(temp)
  }

  const onChangeSubcategoryImage = (index, value) => {
    let temp = [...subcategoriesImages]
    temp[index] = value
    setSubcategoriesImages(temp)
  }

  return (
    <>
      <DashboardLayout>
        <div className="dashCard mb-4">
          <div className="row mb-3">
            <div className="col-12">
              <h2 className="mainTitle">
                <BackButton />
                Add New Category
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-4">
              <CustomInput
                label="Category Name"
                labelClass="mainLabel"
                required
                placeholder="Enter Category Name"
                inputClass="mainInput"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="col-4">
              <label className="mainLabel d-block">Section <span className="text-danger">*</span></label>
              <select
                className="sectionSelect"
                value={section}
                onChange={e => setSection(e.target.value)}
              >
                {SECTIONS.map(s => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
            <div className="col-4">
              <label className="mainLabel d-block">Category Icon</label>
              <CustomButton text="Upload" variant="primaryButton" onClick={() => categoryRef.current.click()} />
              <input type="file" hidden ref={categoryRef} onChange={e => setCategoryImage(e.target.files[0])} />
              {
                categoryImage &&
                <div className="d-flex mt-3">
                  <img className="mx-2" src={URL.createObjectURL(categoryImage)} style={{ width: '160px', height: '160px', objectFit: 'contain', borderRadius: 12, backgroundColor: '#F0F0F0' }} />
                </div>
              }
            </div>
          </div>
          <h4>
            Subcategories
          </h4>
          {
            subcategories.map((item, index) => (
              <div className="row mb-3">
                <div className="col-8 d-flex flex-row align-items-center">
                  <h5 className="me-3 mb-2">{index + 1}.</h5>
                  <div className="row">
                    <div className="col-8">
                      <CustomInput
                        containerClass="w-100"
                        placeholder="Enter Subcategory"
                        inputClass="mainInput"
                        value={item}
                        onChange={e => onChangeSubcategory(index, e.target.value)}
                      />
                    </div>
                    <div className="col-4">
                      <CustomButton text="Upload" variant="primaryButton" onClick={() => ref.current.click()} />
                      <input
                        type="file"
                        hidden
                        ref={ref}
                        onChange={e => onChangeSubcategoryImage(index, e.target.files[0])} />
                    </div>
                  </div>
                  {/* <p className="mainTitle">Select Pictures</p> */}
                  {
                    subcategoriesImages[index] &&
                    <div className="d-flex mb-3">
                      <img className="mx-2" src={URL.createObjectURL(subcategoriesImages[index])} style={{ width: '200px', height: '200px', objectFit: 'contain', borderRadius: 12, backgroundColor: '#F0F0F0' }} />
                    </div>
                  }

                  {
                    subcategories.length > 1 &&
                    <h5 className="text-danger ms-3" onClick={() => onManipulateSubcategory("minus", index)}>-</h5>
                  }
                  {
                    index === subcategories.length - 1 &&
                    <h5
                      className="ms-3"
                      onClick={() => onManipulateSubcategory("add")}>+</h5>
                  }
                </div>
              </div>
            ))
          }
          <div className="row mb-3">
            <div className="col-4">
              <CustomButton
                text="Save"
                className="primaryButton"
                onClick={onClickSave}
                loading={isLoading || imageLoading}
              />
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default AddCategory;